<template>
  <div class="form-field">
    <md-card-content>
      <div class="md-layout-item md-small-size-100">
        <md-field class="number-id">
          <md-input type="text" v-model="value.id"/>
        </md-field>
        <md-field class="number-documentName" :class="messageClass('name')">
          <label for="documentName"><span v-lang.name></span></label>
          <md-input type="text" name="documentName" v-model="value.name"/>
          <span class="md-error">{{ errors.name }}</span>
        </md-field>
      </div>
    </md-card-content>
  </div>
</template>
<script>
import parseBadRequest from '@/utils/parse-bad-request'
import testForErrorCode from '@/utils/test-for-err-code'
import ERRCODES from '@/utils/error-codes'

export default {
  name: 'DocumentFormFields',
  props: {
    value: {
      type: Object
    },
    errorMessage: {
      type: String
    }
  },
  computed: {
    errors () {
      return this.parseErrorMessage()
    }
  },
  methods: {
    messageClass (field) {
      return {
        'md-invalid': this.errors[field]
      }
    },
    parseErrorMessage () {
      const errors = {}

      const errorMessages = parseBadRequest(this.errorMessage)
      if (errorMessages.length > 0) {
        errorMessages.forEach(errorMsg => {
          if (testForErrorCode(ERRCODES.document.documentNameMinLen, errorMsg)) {
            errors.name = this.translate('error_4_11')
          } else if (testForErrorCode(ERRCODES.document.documentNameMaxLen, errorMsg)) {
            errors.name = this.translate('error_4_12')
          } else {
            this.$error(this.translate('unexpectedError'), 5000)
          }
        })
      }

      return errors
    }
  }
}
</script>

<style lang="scss">
.number-id {
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/documents/DocumentFormFields.vue